// Icons
// import ExploreIcon from "@material-ui/icons/Explore";
import React from 'react'
import RedeemIcon from "@material-ui/icons/Redeem";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import ContactSupportIcon from "@material-ui/icons/ContactSupport";
import PagesIcon from "@material-ui/icons/Pages";
import ScheduleIcon from "@material-ui/icons/Schedule";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import PermMediaIcon from "@material-ui/icons/PermMedia";
import HomeIcon from "@material-ui/icons/Home";
import { GiExplosiveMaterials } from "react-icons/gi";
import AcUnitIcon from '@material-ui/icons/AcUnit';
import { TbListDetails } from "react-icons/tb";

// import AppsIcon from "@material-ui/icons/Apps";
// import PhotoIcon from "@material-ui/icons/Photo";
// import EqualizerIcon from "@material-ui/icons/Equalizer";
// import Looks3Icon from "@material-ui/icons/Looks3";
// import Looks4Icon from "@material-ui/icons/Looks4";
// import ViewColumnIcon from "@material-ui/icons/ViewColumn";
// import ShowChartIcon from "@material-ui/icons/ShowChart";
// import NavigationIcon from "@material-ui/icons/Navigation";

// import FaceIcon from "@material-ui/icons/Face";
// import LocalLibraryIcon from "@material-ui/icons/LocalLibrary";
// import PersonIcon from "@material-ui/icons/Person";
// import BookmarkIcon from "@material-ui/icons/Bookmark";
// import { Component } from "react";
// Pages
// import Training from "./pages/Training/Training";
// import ListMyFCP from "./pages/MyFCP/ListMyFCP";
// import MyFCP from "./pages/MyFCP/MyFCP";
// import Reports from "./pages/Pages/Reports";
// import ListPayments from "./pages/Payments/ListPayments";
import {
  HomeFCP,
  NewHomeFCP,
  // Calendar,
  // Chat,
  // Media,
  // Messages,
  // Social,
  // Blank,
  // Invoice,
  // PricingPage,
  // TimelinePage,
  ContactUs,
  Content,
  // Charts,
  // Taskboard,
  // Widgets,
  // Lockscreen,
  // PasswordReset,
  // Signin,
  // Signup,
  // Leaflet,
  // Google,
  // Products,
  // Detail,
  // Editor,
  // NotFound,
  // BackendError,
  // AddParticipants,
  // AddPhotos,
  // PlanningWorkshop,
  Funds,
  Profile,
  ListFCPEventsPlanned,
  ListFCPAssignedHPA,
  //NewWorkshop
  // Material Examples
  // AppBar,
  // Autocomplete,
  // Avatars,
  // Badges,
  // ButtonNavigation,
  // Buttons,
  // Cards,
  // Chips,
  // Dialogs,
  // Dividers,
  // Drawers,
  // ExpansionPanels,
  // GridList,
  // Lists,
  // Menus,
  // Paper,
  // Pickers,
  // Progress,
  // SelectionControls,
  // Selects,
  // Snackbars,
  // Steppers,
  // Tables,
  // Tabs,
  // TextFields,
  // Tooltips,
  // Notifications
  HomeCMDI,
  HomeAMMD,
  NewProfile,
} from "./pages";
import FevicyrlContent from "./pages/Pages/FevicyrlContent";
import SuperAdmin from "./pages/SuperAdmin/SuperAdmin";

export const FCProutes = {
  items: [
    {
      path: "/newHomeFCP",
      name: "Home",
      type: "link",
      icon: HomeIcon,
      component: NewHomeFCP
    },
    {
      path: "/listFCPAssignedHPA",
      name: "Assigned HPAs",
      icon: SupervisorAccountIcon,
      component: ListFCPAssignedHPA
    },
    {
      path: "/homeFCP",
      name: "Workshops",
      type: "link",
      icon: PagesIcon,
      component: HomeFCP
    },
    {
      path: "/fevicryl-Content",
      name: "Fevicryl Content Categorization",
      type: "link",
      icon: AcUnitIcon,
      component: FevicyrlContent
    },
    // {
    //   path: "/funds",
    //   name: "Funds",
    //   type: "link",
    //   icon: RedeemIcon,
    //   component: Funds
    // },
    {
      path: "/profile",
      name: "My Profile",
      type: "link",
      icon: AccountBoxIcon,
      component: NewProfile
    },
    {
      path: "/Info",
      name: "Info",
      type: "link",
      icon: AccountBoxIcon,
      component: Profile
    },
    {
      path: "/listFCPEventsPlanned",
      name: "Events Planned",
      icon: ScheduleIcon,
      component: ListFCPEventsPlanned
    },
    {
      path: "/content",
      name: "View training content",
      icon: PermMediaIcon,
      component: Content
    },
    {
      path: "/contact-us",
      name: "Contact Us",
      icon: ContactSupportIcon,
      component: ContactUs
    }
  ]
};

export const CMDIroutes = {
  items: [
    {
      path: "/homeCMDI",
      name: "Workshops",
      type: "link",
      icon: PagesIcon,
      component: HomeCMDI
    }
    // {
    //   path: "/funds",
    //   name: "Funds",
    //   type: "link",
    //   icon: RedeemIcon,
    //   component: Funds
    // },
    // {
    //   path: "/training",
    //   name: "Training",
    //   icon: ContactSupportIcon,
    //   component: Training
    // },
    // {
    //   path: "/listMyFCP",
    //   name: "List My FCP",
    //   icon: ContactSupportIcon,
    //   component: ListMyFCP
    // },
    // {
    //   path: "/myFCP",
    //   name: "My FCP",
    //   icon: ContactSupportIcon,
    //   component: MyFCP
    // },
    // {
    //   path: "/reports",
    //   name: "Reports",
    //   icon: ContactSupportIcon,
    //   component: Reports
    // },
    // {
    //   path: "/listPayments",
    //   name: "List Payments",
    //   icon: ContactSupportIcon,
    //   component: ListPayments
    // }
  ]
};

export const AMMDroutes = {
  items: [
    {
      path: "/homeAMMD",
      name: "Workshops",
      type: "link",
      icon: PagesIcon,
      component: HomeAMMD
    }
  ]
};

// export default {
//   items: [
//     {
//       path: "/",
//       name: "Workshops",
//       type: "link",
//       icon: PagesIcon,
//       component: Home
//     },
//     // {
//     //   path: "/notifications",
//     //   name: "Notifications",
//     //   type: "link",
//     //   icon: ExploreIcon,
//     //   component: Notifications
//     // },
//     {
//       path: "/funds",
//       name: "Funds",
//       type: "link",
//       icon: RedeemIcon,
//       component: Funds
//     },
//     {
//       path: "/profile",
//       name: "My Profile",
//       type: "link",
//       icon: AccountBoxIcon,
//       component: Profile
//     },
//     {
//       path: "/contact-us",
//       name: "Contact Us",
//       icon: ContactSupportIcon,
//       component: ContactUs
//     }
//     // {
//     //   path: "/funds",
//     //   name: "Funds",
//     //   icon: ExploreIcon,
//     //   component: Blank
//     // },

//     // {
//     //   path: '/apps',
//     //   name: 'Apps',
//     //   type: 'submenu',
//     //   icon: AppsIcon,
//     //   badge: {
//     //     type: 'primary',
//     //     value: '5'
//     //   },
//     //   children: [{
//     //     path: '/calendar',
//     //     name: 'Calendar',
//     //     component: Calendar
//     //   },
//     //   {
//     //     path: '/media',
//     //     name: 'Media',
//     //     component: Media
//     //   },
//     //   {
//     //     path: '/messages',
//     //     name: 'Messages',
//     //     component: Messages
//     //   },
//     //   {
//     //     path: '/social',
//     //     name: 'Social',
//     //     component: Social
//     //   },
//     //   {
//     //     path: '/chat',
//     //     name: 'Chat',
//     //     component: Chat
//     //   }
//     //   ]
//     // },
//     // {
//     //   path: '/widgets',
//     //   name: 'Widgets',
//     //   type: 'link',
//     //   icon: PhotoIcon,
//     //   component: Widgets
//     // },
//     // {
//     //   path: '/material',
//     //   name: 'Material',
//     //   type: 'submenu',
//     //   icon: EqualizerIcon,
//     //   badge: {
//     //     type: 'error',
//     //     value: '10'
//     //   },
//     //   children: [{
//     //     path: '/appbar',
//     //     name: 'App Bar',
//     //     component: AppBar
//     //   },
//     //   {
//     //     path: '/autocomplete',
//     //     name: 'Auto Complete',
//     //     component: Autocomplete
//     //   },
//     //   {
//     //     path: '/avatars',
//     //     name: 'Avatars',
//     //     component: Avatars
//     //   },
//     //   {
//     //     path: '/badges',
//     //     name: 'Badges',
//     //     component: Badges
//     //   },
//     //   {
//     //     path: '/button-navigation',
//     //     name: 'Button Navigation',
//     //     component: ButtonNavigation
//     //   },
//     //   {
//     //     path: '/buttons',
//     //     name: 'Buttons',
//     //     component: Buttons
//     //   },
//     //   {
//     //     path: '/cards',
//     //     name: 'Cards',
//     //     component: Cards
//     //   },
//     //   {
//     //     path: '/chips',
//     //     name: 'Chips',
//     //     component: Chips
//     //   },
//     //   {
//     //     path: '/dialogs',
//     //     name: 'Dialogs',
//     //     component: Dialogs
//     //   },
//     //   {
//     //     path: '/dividers',
//     //     name: 'Dividers',
//     //     component: Dividers
//     //   },
//     //   {
//     //     path: '/drawers',
//     //     name: 'Drawers',
//     //     component: Drawers
//     //   },
//     //   {
//     //     path: '/expansion-panels',
//     //     name: 'Expansion Panels',
//     //     component: ExpansionPanels
//     //   },
//     //   {
//     //     path: '/grid-list',
//     //     name: 'Grid List',
//     //     component: GridList
//     //   },
//     //   {
//     //     path: '/lists',
//     //     name: 'Lists',
//     //     component: Lists
//     //   },
//     //   {
//     //     path: '/menus',
//     //     name: 'Menus',
//     //     component: Menus
//     //   },
//     //   {
//     //     path: '/paper',
//     //     name: 'Paper',
//     //     component: Paper
//     //   },
//     //   {
//     //     path: '/pickers',
//     //     name: 'Pickers',
//     //     component: Pickers
//     //   },
//     //   {
//     //     path: '/progress',
//     //     name: 'Progress',
//     //     component: Progress
//     //   },
//     //   {
//     //     path: '/selection-controls',
//     //     name: 'Selection Controls',
//     //     component: SelectionControls
//     //   },
//     //   {
//     //     path: '/selects',
//     //     name: 'Selects',
//     //     component: Selects
//     //   },
//     //   {
//     //     path: '/snackbars',
//     //     name: 'Snackbars',
//     //     component: Snackbars
//     //   },
//     //   {
//     //     path: '/steppers',
//     //     name: 'Steppers',
//     //     component: Steppers
//     //   },
//     //   {
//     //     path: '/tables',
//     //     name: 'Tables',
//     //     component: Tables
//     //   },
//     //   {
//     //     path: '/tabs',
//     //     name: 'Tabs',
//     //     component: Tabs
//     //   },
//     //   {
//     //     path: '/text-fields',
//     //     name: 'Text Fields',
//     //     component: TextFields
//     //   },
//     //   {
//     //     path: '/tooltips',
//     //     name: 'Tooltips',
//     //     component: Tooltips
//     //   }
//     //   ]
//     // },
//     // {
//     //   path: '/editor',
//     //   name: 'Editor',
//     //   type: 'link',
//     //   icon: Looks3Icon,
//     //   component: Editor
//     // },
//     // {
//     //   path: '/ecommerce',
//     //   name: 'Ecommerce',
//     //   type: 'submenu',
//     //   icon: Looks4Icon,
//     //   badge: {
//     //     type: 'secondary',
//     //     value: 'N'
//     //   },
//     //   children: [{
//     //     path: '/products',
//     //     name: 'Products',
//     //     component: Products
//     //   },
//     //   {
//     //     path: '/detail',
//     //     name: 'Detail',
//     //     component: Detail
//     //   },
//     //   ]
//     // },
//     // {
//     //   path: '/taskboard',
//     //   name: 'Taskboard',
//     //   type: 'link',
//     //   icon: ViewColumnIcon,
//     //   component: Taskboard
//     // },
//     // {
//     //   path: '/charts',
//     //   name: 'Charts',
//     //   type: 'link',
//     //   icon: ShowChartIcon,
//     //   component: Charts
//     // },
//     // {
//     //   path: '/maps',
//     //   name: 'Maps',
//     //   type: 'submenu',
//     //   icon: NavigationIcon,
//     //   children: [{
//     //     path: '/google',
//     //     name: 'Google',
//     //     component: Google
//     //   },
//     //   {
//     //     path: '/leaflet',
//     //     name: 'Leaflet',
//     //     component: Leaflet
//     //   }
//     //   ]
//     // },
//     // {
//     //   path: "/pages",
//     //   name: "Pages",
//     //   type: "submenu",
//     //   icon: PagesIcon,
//     //   children: [
//     //     {
//     //       path: "/invoice",
//     //       name: "Invoice",
//     //       component: Invoice
//     //     },
//     //     {
//     //       path: "/timeline",
//     //       name: "Timeline",
//     //       component: TimelinePage
//     //     },
//     //     {
//     //       path: "/blank",
//     //       name: "Blank",
//     //       component: Blank
//     //     },
//     //     {
//     //       path: "/pricing",
//     //       name: "Pricing",
//     //       component: PricingPage
//     //     },
//     //     {
//     //       path: "/addParticipants",
//     //       name: "Add Participants",
//     //       Component: AddParticipants
//     //     },
//     //     {
//     //       path: "/addPhotos",
//     //       name: "Add Photos",
//     //       Component: AddPhotos
//     //     },
//     //     {
//     //       path: "/planningWorkshop",
//     //       name: "Planning Workshop",
//     //       Component: PlanningWorkshop
//     //     },
//     //     {
//     //       path: "/notifications",
//     //       name: "Notifications",
//     //       Component: Notifications
//     //     }
//     //   ]
//     // }
//     // {
//     //   name: 'Authentication',
//     //   type: 'submenu',
//     //   icon: PersonIcon,
//     //   children: [{
//     //     path: '/signin',
//     //     name: 'Signin',
//     //     component: Signin
//     //   },
//     //   {
//     //     path: '/signup',
//     //     name: 'Signup',
//     //     component: Signup
//     //   },
//     //   {
//     //     path: '/forgot',
//     //     name: 'Forgot',
//     //     component: PasswordReset
//     //   },
//     //   {
//     //     path: '/lockscreen',
//     //     name: 'Lockscreen',
//     //     component: Lockscreen
//     //   },
//     //   ]
//     // },
//     // {
//     //   name: 'Error',
//     //   type: 'submenu',
//     //   icon: FaceIcon,
//     //   children: [{
//     //     path: '/404',
//     //     name: '404',
//     //     component: NotFound
//     //   },
//     //   {
//     //     path: '/500',
//     //     name: 'Error',
//     //     component: BackendError
//     //   },
//     //   ]
//     // },
//     // {
//     //   path: 'https://iamnyasha.github.io/react-primer-docs/',
//     //   name: 'Documentation',
//     //   type: 'external',
//     //   icon: LocalLibraryIcon
//     // },
//     // {
//     //   path: 'https://primer.nyasha.me',
//     //   name: 'Get Angular Version',
//     //   type: 'external',
//     //   icon: BookmarkIcon
//     // }
//   ]
// };
